import { RouterModule, Routes } from "@angular/router";
import { CrmComponent } from "./crm.component";
import { NgModule } from "@angular/core";

const routes: Routes = [
  { path: '', component: CrmComponent },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class CrmRoutingModule {
}
